import React, { useState, useEffect } from 'react';
import { chavesAPI, categoriasAPI } from '../services/api';
import * as XLSX from 'xlsx';
import { IconChart } from '../components/icons';
import './Relatorios.css';

function Relatorios() {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campeoes, setCampeoes] = useState([]);
  const [filterCategoria, setFilterCategoria] = useState('');

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    try {
      const [chavesRes, categoriasRes] = await Promise.all([
        chavesAPI.getAll(),
        categoriasAPI.getAll()
      ]);
      
      setCategorias(categoriasRes.data);
      
      // Processar campeões de cada chave
      const campeoesData = processarCampeoes(chavesRes.data);
      setCampeoes(campeoesData);
      
      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setLoading(false);
    }
  };

  const processarCampeoes = (chavesData) => {
    const resultado = [];

    chavesData.forEach(chave => {
      if (!chave.rodadas || chave.rodadas.length === 0) return;

      // Encontrar a final (última rodada)
      const rodadaFinal = chave.rodadas[chave.rodadas.length - 1];
      const rodadaSemifinal = chave.rodadas.length > 1 ? chave.rodadas[chave.rodadas.length - 2] : null;

      if (rodadaFinal && rodadaFinal.lutas && rodadaFinal.lutas[0]) {
        const lutaFinal = rodadaFinal.lutas[0];
        
        // 1º Lugar - Vencedor da final
        const primeiroLugar = lutaFinal.vencedor;
        
        // 2º Lugar - Perdedor da final
        let segundoLugar = null;
        if (lutaFinal.atleta1 && lutaFinal.atleta2) {
          if (primeiroLugar && primeiroLugar.id === lutaFinal.atleta1.id) {
            segundoLugar = lutaFinal.atleta2;
          } else if (primeiroLugar && primeiroLugar.id === lutaFinal.atleta2.id) {
            segundoLugar = lutaFinal.atleta1;
          }
        }

        // 3º Lugar - Perdedor(es) da semifinal
        let terceiroLugar = null;
        if (rodadaSemifinal && rodadaSemifinal.lutas) {
          // Pega os perdedores da semifinal que não foram para a final
          const perdedoresSemi = rodadaSemifinal.lutas
            .filter(luta => luta.vencedor)
            .map(luta => {
              if (luta.atleta1 && luta.atleta2 && luta.vencedor) {
                return luta.vencedor.id === luta.atleta1.id ? luta.atleta2 : luta.atleta1;
              }
              return null;
            })
            .filter(atleta => atleta !== null);

          // Terceiro lugar é o primeiro perdedor da semifinal
          if (perdedoresSemi.length > 0) {
            terceiroLugar = perdedoresSemi[0];
          }
        }

        resultado.push({
          chave_id: chave.id,
          numero_chave: chave.numero_chave,
          categoria_id: chave.categoria_id,
          categoria_nome: chave.categoria_nome,
          faixa: chave.faixa,
          primeiro: primeiroLugar,
          segundo: segundoLugar,
          terceiro: terceiroLugar
        });
      }
    });

    return resultado;
  };

  const exportarParaExcel = () => {
    const dados = campeoesFilter.map(c => ({
      'Categoria': c.categoria_nome,
      'Faixa': c.faixa || 'N/A',
      '1º Lugar': c.primeiro ? c.primeiro.nome : 'Não definido',
      'Academia (1º)': c.primeiro ? c.primeiro.academia_nome || 'N/A' : 'N/A',
      '2º Lugar': c.segundo ? c.segundo.nome : 'Não definido',
      'Academia (2º)': c.segundo ? c.segundo.academia_nome || 'N/A' : 'N/A',
      '3º Lugar': c.terceiro ? c.terceiro.nome : 'Não definido',
      'Academia (3º)': c.terceiro ? c.terceiro.academia_nome || 'N/A' : 'N/A',
    }));

    const ws = XLSX.utils.json_to_sheet(dados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Campeões');
    
    // Ajustar largura das colunas
    const colWidths = [
      { wch: 25 }, // Categoria
      { wch: 15 }, // Faixa
      { wch: 30 }, // 1º Lugar
      { wch: 25 }, // Academia (1º)
      { wch: 30 }, // 2º Lugar
      { wch: 25 }, // Academia (2º)
      { wch: 30 }, // 3º Lugar
      { wch: 25 }, // Academia (3º)
    ];
    ws['!cols'] = colWidths;

    XLSX.writeFile(wb, `Relatorio_Campeoes_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const exportarParaPDF = () => {
    const printWindow = window.open('', '_blank');
    
    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Relatório de Campeões</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }
          h1 {
            text-align: center;
            color: #333;
          }
          .info {
            text-align: center;
            color: #666;
            margin-bottom: 30px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 12px;
            text-align: left;
          }
          th {
            background-color: #667eea;
            color: white;
            font-weight: bold;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          .podio {
            display: inline-block;
            padding: 4px 8px;
            border-radius: 4px;
            font-weight: bold;
            color: white;
          }
          .primeiro { background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%); }
          .segundo { background: linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%); }
          .terceiro { background: linear-gradient(135deg, #CD7F32 0%, #B8860B 100%); }
          @media print {
            button { display: none; }
          }
        </style>
      </head>
      <body>
        <h1>🏆 Relatório de Campeões</h1>
        <div class="info">
          <p>SIGE - Sistema de Gerenciamento de Eventos</p>
          <p>Data: ${new Date().toLocaleDateString('pt-BR')}</p>
        </div>
        
        ${campeoesFilter.map(c => `
          <h2>${c.categoria_nome}${c.faixa ? ' - ' + c.faixa : ''}</h2>
          <table>
            <thead>
              <tr>
                <th>Posição</th>
                <th>Atleta</th>
                <th>Academia</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="podio primeiro">🥇 1º Lugar</span></td>
                <td>${c.primeiro ? c.primeiro.nome : 'Não definido'}</td>
                <td>${c.primeiro ? (c.primeiro.academia_nome || 'N/A') : 'N/A'}</td>
              </tr>
              <tr>
                <td><span class="podio segundo">🥈 2º Lugar</span></td>
                <td>${c.segundo ? c.segundo.nome : 'Não definido'}</td>
                <td>${c.segundo ? (c.segundo.academia_nome || 'N/A') : 'N/A'}</td>
              </tr>
              <tr>
                <td><span class="podio terceiro">🥉 3º Lugar</span></td>
                <td>${c.terceiro ? c.terceiro.nome : 'Não definido'}</td>
                <td>${c.terceiro ? (c.terceiro.academia_nome || 'N/A') : 'N/A'}</td>
              </tr>
            </tbody>
          </table>
        `).join('')}
        
        <div style="margin-top: 40px; text-align: center;">
          <button onclick="window.print()" style="padding: 10px 20px; background: #667eea; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 16px;">
            Imprimir / Salvar como PDF
          </button>
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(html);
    printWindow.document.close();
  };

  const campeoesFilter = filterCategoria 
    ? campeoes.filter(c => c.categoria_id === filterCategoria)
    : campeoes;

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="relatorios-container">
      <div className="page-header">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><IconChart /> Relatório de Campeões</h1>
        <p>Visualize os vencedores de todas as categorias</p>
      </div>

      <div className="relatorios-actions">
        <div className="filter-section">
          <select
            value={filterCategoria}
            onChange={(e) => setFilterCategoria(e.target.value)}
            className="filter-select"
          >
            <option value="">Todas as Categorias</option>
            {categorias.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.nome}</option>
            ))}
          </select>
        </div>

        <div className="export-buttons">
          <button className="btn btn-success" onClick={exportarParaExcel}>
            📊 Exportar para Excel
          </button>
          <button className="btn btn-danger" onClick={exportarParaPDF}>
            📄 Exportar para PDF
          </button>
        </div>
      </div>

      {campeoesFilter.length === 0 ? (
        <div className="card empty-state">
          <h3>Nenhum campeão definido ainda</h3>
          <p>Complete as chaves e marque os vencedores para ver o relatório</p>
        </div>
      ) : (
        <div className="campeoes-grid">
          {campeoesFilter.map((c, index) => (
            <div key={c.chave_id} className="campeao-card">
              <div className="campeao-header">
                <h3>{c.categoria_nome}</h3>
                {c.faixa && <span className="faixa-badge">{c.faixa}</span>}
              </div>

              <div className="podio">
                <div className="podio-item primeiro">
                  <div className="podio-medal">🥇</div>
                  <div className="podio-info">
                    <div className="podio-posicao">1º Lugar</div>
                    <div className="podio-nome">
                      {c.primeiro ? c.primeiro.nome : 'Não definido'}
                    </div>
                    <div className="podio-academia">
                      {c.primeiro ? (c.primeiro.academia_nome || 'Academia não informada') : ''}
                    </div>
                  </div>
                </div>

                <div className="podio-item segundo">
                  <div className="podio-medal">🥈</div>
                  <div className="podio-info">
                    <div className="podio-posicao">2º Lugar</div>
                    <div className="podio-nome">
                      {c.segundo ? c.segundo.nome : 'Não definido'}
                    </div>
                    <div className="podio-academia">
                      {c.segundo ? (c.segundo.academia_nome || 'Academia não informada') : ''}
                    </div>
                  </div>
                </div>

                <div className="podio-item terceiro">
                  <div className="podio-medal">🥉</div>
                  <div className="podio-info">
                    <div className="podio-posicao">3º Lugar</div>
                    <div className="podio-nome">
                      {c.terceiro ? c.terceiro.nome : 'Não definido'}
                    </div>
                    <div className="podio-academia">
                      {c.terceiro ? (c.terceiro.academia_nome || 'Academia não informada') : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Relatorios;
